import { leadLadies } from '@/mocks/home';

export default function LeadLadies() {
  return (
    <section id="actress" className="w-full px-4 md:px-8 py-14 md:py-20 bg-background-100/60">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 md:gap-8">
          <div className="lg:col-span-1 reveal">
            <div className="relative w-full h-[320px] md:h-[420px] rounded-lg overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Elegant%20abstract%20silhouette%20of%20a%20woman%20against%20warm%20peach%20and%20rose%20gradient%20light%2C%20soft%20studio%20backlight%2C%20grainy%20analog%20film%20texture%2C%20anonymized%20artistic%20portrait%2C%20no%20face%20details%2C%20cinematic%20mood%2C%20high%20detail%2C%20no%20text&width=900&height=1100&seq=peach-actress-01&orientation=portrait"
                alt="暖色光影下的女性剪影，呼应两代女主角的银幕形象讨论"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 to-transparent" />
              <div className="absolute bottom-5 left-5 right-5 text-background-50">
                <p className="font-heading text-lg md:text-xl font-bold">女主角是谁</p>
                <p className="text-background-50/75 text-xs mt-1">原版与 3D 版的核心人物对照</p>
              </div>
            </div>
          </div>

          <div className="lg:col-span-2">
            <span className="text-primary-600 font-label text-sm tracking-wide">人物解读</span>
            <h2 className="mt-2 font-heading text-2xl md:text-4xl font-bold text-foreground-950">
              谁来接住“蜜桃”这个名字
            </h2>
            <p className="mt-3 text-foreground-600 text-sm md:text-base leading-relaxed">
              经典 IP 的翻拍，选角往往是最先被讨论、也最难被认可的一环。下面这些名字，构成了两代作品的演员坐标。
            </p>

            <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-4">
              {leadLadies.map((person, index) => (
                <div
                  key={person.name}
                  className="reveal bg-background-50 border border-background-200/80 rounded-lg p-5"
                  style={{ animationDelay: `${index * 70}ms` }}
                >
                  <div className="flex items-center justify-between gap-3">
                    <p className="font-heading text-lg font-bold text-foreground-950">{person.name}</p>
                    <span
                      className={`px-2.5 py-0.5 rounded-full text-[11px] font-label whitespace-nowrap ${
                        person.era.includes('原版')
                          ? 'bg-secondary-100 text-secondary-700'
                          : 'bg-primary-100 text-primary-700'
                      }`}
                    >
                      {person.era}
                    </span>
                  </div>
                  <p className="mt-1 text-accent-700 text-xs md:text-sm font-label">{person.role}</p>
                  <p className="mt-3 text-foreground-600 text-xs md:text-sm leading-relaxed">{person.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}